import UrlNormalizers from './url-normalizers';

export function normalizeUrl(url: string): string {
  if (!url) return url;
  const parsed = new URL(url);
  const domain = parsed.hostname;
  switch (domain) {
    case 'www.alibaba.com':
    case 'www.aliexpress.com':
    case 'vi.aliexpress.com':
    case 'de.aliexpress.com':
      return UrlNormalizers.aliexpress(url);
    default:
      return url;
  }
}
